import { useState, useEffect } from "react";
import defaultImg from "assets/images/global-site.webp"
import DefaultSiteIcon from "assets/svg/default-site-icon";
const Favicon = ({ domain, hasFavIconFile = null,width="w-[25px]" }) => {
  const [favicon, setFavicon] = useState('');

  useEffect(() => {
    // const cleanUrl = domain?.split('#')[0];
    // const newFavicon = `http://www.google.com/s2/favicons?domain=${cleanUrl}&sz=32`;
    // setFavicon(newFavicon);

    // const img = new Image();
    // img.src = newFavicon;

    // img.onload = () => {
    //   if (img.width <= 16 && img.height <= 16) { //the default image is too small and blur
    //     setFavicon(defaultImg); 
    //   }
    // };

    try {
      let hostname = new URL(domain).hostname;
      const url = hasFavIconFile ? hasFavIconFile : `https://icons.duckduckgo.com/ip3/${hostname}.ico`;
      setFavicon(url); 
    } catch (error) {
      setFavicon(defaultImg); 
    }
  }, [domain]);

  return <>
    {
      hasFavIconFile ?
        <img className={width} src={favicon} alt="Favicon" onError={(e)=> e.src = defaultImg}/>
        :
        <DefaultSiteIcon/>
    }
  </>
};

export default Favicon;
